import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

// Comments
import {Typography} from '@nur-portal/ui-kit';

import {getFormattedDate} from '../../../utils/date';

// Styles
import styles from './comment.module.css';

const CommentCard = ({text, userName, date, className, children, level}) => {
  const {i18n} = useTranslation();

  const isMobile = window.matchMedia('(max-width: 755px)').matches;
  const MOBILE_FIRST_LEVEL_LENGTH_LIMIT = 20;
  const MOBILE_REST_LEVEL_LENGTH_LIMIT = 10;
  const DESKTOP_FIRST_LEVEL_LENGTH_LIMIT = 30;
  const DESKTOP_REST_LEVEL_LENGTH_LIMIT = 20;
  const FIRST_LEVEL = 1;

  let currentLimit = isMobile ? MOBILE_FIRST_LEVEL_LENGTH_LIMIT : DESKTOP_FIRST_LEVEL_LENGTH_LIMIT;

  if (level !== FIRST_LEVEL) {
    currentLimit = isMobile ? MOBILE_REST_LEVEL_LENGTH_LIMIT : DESKTOP_REST_LEVEL_LENGTH_LIMIT;
  }

  let formattedUserName = '';

  if (userName?.length > currentLimit) {
    formattedUserName = `${userName?.slice(0, currentLimit)}...`;
  }

  return (
    <div className={className}>
      <div className={styles.cardHeader}>
        <Typography variant='title-14'>
          { formattedUserName || userName }
        </Typography>
        <Typography
          variant='text-14'
          className={styles.dateText}
          component='time'
          dateTime={new Date(date).toISOString()}
        >
          {getFormattedDate(date, i18n.language)}
        </Typography>
      </div>
      <Typography className={styles.cardText}>{ text }</Typography>
      {children}
    </div>
  );
};

CommentCard.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  level: PropTypes.number
};

CommentCard.defaultProps = {
  className: '',
  children: null,
  level: 1
};

export default CommentCard;
